import {
  exception
} from '../../util/decorators';
import BaseApi from './BaseApi';

export default class OtherApi extends BaseApi {
  @exception('获取关于我们失败')
  getAbout(params) {
    return this.httpJsonp('/misc/about', params)
  }

  @exception('获取配置失败')
  getSetting(params) {
    return this.httpGet('/setting/index', params)
  }

  @exception('获取轮播图失败')
  getBanners(params) {
    return this.httpJsonp('/movie/flash', params)
  }

  @exception('获取代祷支持失败')
  getPrayerSupport(params) {
    return this.httpJsonp('/prayersupport/index', params)
  }

  @exception('提交反馈失败')
  feedback(params) {
    return this.httpJsonp('/feedback/submit', params)
  }

  getJsSign(params) {
    return this.httpJsonp('//wechat.sanmanuela.com/api/weixin/tool/share.php', params)
  }

  getPaySetting() {
    return this.httpJsonp('/misc/miniapp_pay')
  }
}



// WEBPACK FOOTER //
// ./src/service/api/OtherApi.js